import "./DigitalMenu.scss";

export default function DigitalMenu() {
  function goToOnlineMenus() {
    window.location.href = "/feature/online-menu.html";
  }

  function goToQrCodes() {
    window.location.href = "/feature/menu-qr-code.html";
  }

  function goToLinkPages() {
    window.location.href = "/feature/restaurant-landing-pages.html";
  }

  function goToDSAFeature() {
    window.location.href = "/feature/digital-menu-board-solution.html";
  }


  function openTab(url: string) {
    window.open(url, '_blank')
  }

  return (
    <div className={"digital-menu"}>
      <section onClick={goToDSAFeature}>
        <img
          loading="lazy" className="dsa-app"
          src={"https://timber.mhmcdn.com/site/marketing/digitaldropdown/DSAThumb.webp"}
          alt={"Digital Signage App"} />
        <label>
          Display App
        </label>
      </section>

      <section onClick={() => openTab("/content/toast-partner-connect")}>
        <img loading="lazy" className="toast" src={"https://timber.mhmcdn.com/site/marketing/homepage/partners-carousel/ToastNavThumb.webp"} alt={"Toast POS"} />
        <label>Toast POS</label>
        <h5>Cloud-Based POS</h5> 
      </section>

      <section onClick={goToQrCodes}>
        <img
          loading="lazy"
          src={"https://timber.mhmcdn.com/site/marketing/digitaldropdown/QRThumb.webp"}
          alt={"QR Codes"}
        />
        <label>QR Codes</label>
      </section>

      <section onClick={goToLinkPages}>
        <img
          loading="lazy"
          src={"https://timber.mhmcdn.com/site/marketing/digitaldropdown/LPThumb.webp"}
          alt={"Link Pages"}
        />
        <label>Link Pages</label>
      </section>

      <section onClick={goToOnlineMenus}>
        <img
          loading="lazy"
          src={"https://timber.mhmcdn.com/site/marketing/digitaldropdown/OMThumb.webp"}
          alt={"Online Menus"}
        />
        <label>Online Menus</label>
      </section>
    </div>
  );
}
